module.exports = __webpack_public_path__ + "static/media/1982_NationalConvention.b6d88a8d.jpg";